module.exports = __webpack_public_path__ + "media/packs/images/flags/CL-c3ad704f58d933733470b97dd93211ae.svg";